export default "/images/vendor/flag-icon-css/flags/4x3/md.svg?4d08e48ef4cfb7c192dc4a833ededb93";